import React from "react";
import { useSelector } from "react-redux";
import { InfinitySpin } from "react-loader-spinner";

const GlobalLoader = () => {
  const isLoading = useSelector((state) => state.loader.isLoading);

  if (!isLoading) return null;

  return (
    <div
      className='fixed inset-0 flex items-center justify-center bg-[#000000] bg-opacity-50'
      style={{ zIndex: 999999999 }}
    >
      <div className='p-1 min-[50rem] rounded-md py-5 bg-[#ffffff] flex flex-col gap-12 items-center justify-center'>
        <InfinitySpin
          color='var(--secondary-blue-color-600)'
          ariaLabel='loading'
        />
        <p className='text-xl font-[500] leading-[3rem]'>
          Loading, please wait...
        </p>
      </div>
    </div>
  );
};

export default GlobalLoader;
